import { render, staticRenderFns } from "./PazientePatologie.vue?vue&type=template&id=e19274ee&scoped=true"
import script from "./PazientePatologie.vue?vue&type=script&lang=js"
export * from "./PazientePatologie.vue?vue&type=script&lang=js"
import style0 from "./PazientePatologie.vue?vue&type=style&index=0&id=e19274ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19274ee",
  null
  
)

export default component.exports